import logo from '../logo.svg';

import {useState} from "react";
import {
  //withAuthenticator,
  Button,
  Heading,
  Image,
  View,
  Card,
  Theme,
  ThemeProvider,
} from "@aws-amplify/ui-react";



import './App.css';
import Form from '../form/index';

import {Amplify} from 'aws-amplify';
import {withAuthenticator} from '@aws-amplify/ui-react';
import style from "@aws-amplify/ui-react/styles.css";
import awsExports from '../aws-exports';
import { Auth } from 'aws-amplify';
Amplify.configure(awsExports);

//function App({signOut}) {
//function App(){
function App({signOut,user}) {

  const userEmail = user.attributes.email;

  //get user token
  const getToken = async () => {
    const user = await Auth.currentAuthenticatedUser();
    const token = user.signInUserSession.idToken.jwtToken;
    console.log("token: ", token);
    return token;
};
 
  const [buttonText,setButtonText] = useState("Click to Begin");
  const [formShown,setFormShown] = useState(false);
  const formStart =  ()=> {
     setFormShown(!formShown);
    if(formShown===true){
      setButtonText("Click to Begin");
    }else{

     setButtonText("Click to Close");
    }
  }

  const [form1State,setForm1State] = useState({
    userName: "",
    email: "",
    message: "",
    question: "",
  });

  const form1 = <Form
  userEmail = {userEmail}

  />

  const getCred = async ()=>{
    /*console.log(Auth.currentUserCredentials());
    console.log(Auth.currentSession().then(res=>{
      let accessTok= res.getAccessToken()
      let jwt = accessTok.getJwtToken()
      console.log("Access: " + JSON.stringify(accessTok));
      console.log("jwt: " + jwt);
      
    }));*/

    //console.log("new one");
    const user = await Auth.currentAuthenticatedUser();
    const token = user.signInUserSession.idToken.jwtToken;
    console.log("token: ", token);
  }




  return (
    <View className="App">
      <br></br>
      <header className="App-header">
      Contact Form
      </header>
      <div className="App-header-welcome-margin">
      <span>
      <h2 className=" App-header-welcome ">Hello {user.username}</h2>
      <Button variation="primary" className="button"  onClick={signOut}>Sign Out</Button>
      </span>
      </div>
      <div className="App-button-begin-margin"> 
      <Button variation="primary" onClick={formStart}>{buttonText}</Button>
      {formShown && form1}
      </div>
      {/*<ThemeProvider Theme={theme} colorMode="light">
      <Button variation="primary" onClick={getCred}>getCreds</Button>  
  </ThemeProvider>  */} 
{/*      <Button variation="primary" onClick={getCred}>getCreds</Button>  
*/}
      <h3 className=" App-footer ">Doing is Believing</h3>
    </View>
  );
}

/*function App() {
  return (
    <div className="App">
     
      <header className="App-header">
      <header1>This is the main test</header1>
        
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        
       
      </header>
    </div>
  );
}*/

//export default App;

export default withAuthenticator(App, {
  loginMechanisms: ['email']
});


